import React from "react";
import {t, GO_BACK_TO_HOME } from "../../translations/Edit";
import { tCommon,OK } from "../../translations/Common";
const AlertFail = (props) => {
    const { msg, className = "",btnText="",onClose="" } = props;
    return (
        <div className="alert" >
            <div
                className={`confirmation ${className}`}
                onClick={(e) => e.stopPropagation()}
                style={{ background: '#FFF2E2', paddingBottom: '30px' }}
            >
                <div
                    className="alert--content success"
                    style={{ width: "100%", padding: "30px 20px", background: '#FFF2E2' }}
                >
                    {msg}
                </div>
                <div className="go-to-home" onClick={onClose ? onClose : () => window.location.href = "/"}>{btnText == "OK" ? tCommon(OK) :t(GO_BACK_TO_HOME)}</div>
            </div>
        </div>
    );
};

export default AlertFail;
